import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { APIRequestStatus } from "common-ts/dist/models/APIRequestStatus";
import {
  CategoryReview,
  CategoryReviewListState,
  CategoryReviewRecap,
} from "common-ts/dist/models/CategoryReview";
import { ProductCategory } from "common-ts/dist/models/Product";
import { terbebasClient } from "../terbebasApi";

// Dari common-ts/dist/models - JANGAN TYPO HAIDAR
// DynamoDB Table Name : CategoryReviewTable
//
// CategoryReviewInterface
// export default interface CategoryReview {
//     category: string; // HAIDAR-TODO -> Belum ada guidelinenya
//     timestamp: string;
//     name: string;
//     comment: string;
//     rating: number;
//     displayImageList?: string; // Gambar opsional
//     productNameList?: string; // HAIDAR-TODO => Waktu itu dibiccarakan kalau nama produk opsional -> saat ini masih digunakan karena ikut Figma (nama produk di UI ambil item di indeks pertama)
//     userSub?: string; // Opsional
//   }



// Initial State
// Untuk CreateSlice => Daftar review UNTUK SATU kategori DAN draft review baru
const initialState: CategoryReviewListState = {
  // Read
  categoryReviewRecap: {},
  categoryReviewListDict: {},
  getStatus: APIRequestStatus.Idle,
  getStatusRecap: APIRequestStatus.Idle,

  // Write
  categoryReviewDraft: {}, // Tipenya any
  fileDraft: {}, // Untuk menyimpan gambar yang di-upload : any
  postStatus: APIRequestStatus.Idle,
};

// Terbebas: category reviews are backed by the store's Review table.
// Every terbebas product maps to the 'all' category (allowedReviewCategories
// only contains fareast clothing categories), so both thunks fetch the
// store-wide approved review list and map it onto the legacy shapes.

function mapTerbebasReview(r: any): CategoryReview {
  return {
    category: 'all',
    timestamp: r.createdAt,
    name: r.name,
    comment: (r.headline ? r.headline + ' — ' : '') + (r.message ?? ''),
    rating: r.rating,
    displayImageList: JSON.stringify(r.imageUrls ?? []),
    productNameList: JSON.stringify(r.productTitle ? [r.productTitle] : []),
  };
}

export const fetchCategoryReviewRecap = createAsyncThunk(
  "categoryReviewList/fetchCategoryReviewRecap",
  async (payload: string, thunkAPI) => {
    const response = await terbebasClient.get('/storefront/reviews');
    const recap: CategoryReviewRecap = response.data?.reviewCount
      ? {
        all: {
          averageRating: response.data.averageRating ?? 0,
          numberOfRatings: response.data.reviewCount,
        },
      }
      : {};
    return { success: true, fetchedData: recap };
  }
);

export const fetchCategoryReviewList = createAsyncThunk(
  "categoryReviewList/fetchCategoryReviewList",
  async (payload: string, thunkAPI) => {
    const response = await terbebasClient.get('/storefront/reviews');
    return {
      success: true,
      category: 'all' as ProductCategory,
      categoryReviewList: (response.data?.reviews ?? []).map(mapTerbebasReview),
      lastEvaluatedKey: '' as ProductCategory,
    };
  }
);

// Terbebas: category-level review submission is retired — reviews are
// submitted per product (PageProductOverlayNewReview -> postNewReview,
// with photos via /storefront/uploads). Kept as a no-op because the
// reducer still wires its lifecycle actions.
export const postNewCategoryReview = createAsyncThunk(
  "categoryReviewList/postNewCategoryReview",
  async () => {
    return {};
  }
);

export const categoryReviewListSlice = createSlice({
  name: "categoryReviewList",
  initialState,
  reducers: {
    inputCategoryReviewFileDraft(state, action) {
      state.fileDraft = action.payload;
      console.log(`Nilai Draft Gambar: ${JSON.stringify(state.fileDraft)}`);
    },
    inputCategoryReviewForm: (state, action: PayloadAction<CategoryReview>) => {
      Object.assign(state.categoryReviewDraft, action.payload);
    },
    resetCategoryReviewDraft: (state) => {
      state.categoryReviewDraft = {};
      state.fileDraft = {};
    },
  },
  extraReducers(builder) {
    // HAIDAR-TODO : builder untuk POST
    builder
      .addCase(fetchCategoryReviewRecap.pending, (state, action) => {
        // Ganti status GET di state => BERLANGSUNG
        state.getStatusRecap = APIRequestStatus.RequestInProgress;
      })
      .addCase(fetchCategoryReviewRecap.fulfilled, (state, action) => {
        if (action?.payload && action?.payload?.success) {
          let categoryReviewRecap: CategoryReviewRecap = action.payload.fetchedData;

          state.categoryReviewRecap = categoryReviewRecap;
          console.log(categoryReviewRecap);
        }

        // Ganti status GET di state => BERHASIL
        state.getStatusRecap = APIRequestStatus.Success;
      })
      .addCase(fetchCategoryReviewRecap.rejected, (state, action) => {
        // Ganti status GET di state => GAGAL
        state.getStatusRecap = APIRequestStatus.Failure;
        console.log("Category Review Recap Fetch [GET] Failed");
      })
      .addCase(fetchCategoryReviewList.pending, (state, action) => {
        // Ganti status GET di state => BERLANGSUNG
        state.getStatus = APIRequestStatus.RequestInProgress;
      })
      .addCase(fetchCategoryReviewList.fulfilled, (state, action) => {
        if (action?.payload && action?.payload?.success) {
          let categoryFetched: ProductCategory = action.payload.category;
          let categoryReviewList: CategoryReview[] = action.payload.categoryReviewList;
          let lastEvaluatedKey: ProductCategory = action.payload.lastEvaluatedKey;

          if (state?.categoryReviewListDict?.[categoryFetched] !== undefined) {
            state.categoryReviewListDict[categoryFetched] = {
              // Pakai ini kalau lastEvaluatedKey logic nanti akan diimplementasikan
              // categoryReviewList: (
              //   state.categoryReviewListDict[categoryFetched]?.categoryReviewList === undefined ? 
              //   [] :
              //   (state.categoryReviewListDict[categoryFetched] as any).categoryReviewList
              //   ).concat(categoryReviewList),
              categoryReviewList: categoryReviewList,
              lastEvaluatedKey: lastEvaluatedKey,
            }
          } else {
            state.categoryReviewListDict[categoryFetched] = {
              categoryReviewList: categoryReviewList,
              lastEvaluatedKey: lastEvaluatedKey,
            }
          }
          
        }

        // Ganti status GET di state => BERHASIL
        state.getStatus = APIRequestStatus.Success;
      })
      .addCase(fetchCategoryReviewList.rejected, (state, action) => {
        // Ganti status GET di state => GAGAL
        state.getStatus = APIRequestStatus.Failure;
        console.log("Category Review List Fetch [GET] Failed");
      })
      // Ditto
      .addCase(postNewCategoryReview.pending, (state, action) => {
        state.postStatus = APIRequestStatus.RequestInProgress;
      })
      .addCase(postNewCategoryReview.fulfilled, (state, action) => {
        state.postStatus = APIRequestStatus.Success;
      })
      .addCase(postNewCategoryReview.rejected, (state, action) => {
        state.postStatus = APIRequestStatus.Failure;
        console.log("Category Review Fetch [POST] Failed");
      });
  },
});

// Action creators are generated for each case reducer function
export const {
  inputCategoryReviewFileDraft,
  inputCategoryReviewForm,
  resetCategoryReviewDraft,
} = categoryReviewListSlice.actions;

export default categoryReviewListSlice.reducer;
